import type { SegmentMst } from '@libs/domain';
import type { WithExclusionObject } from '@ps-smart-cp/ppfw-client';

class SingleSegmentMstRange implements Pick<SegmentMst['schema'], 'key' | 'segmentMstCodeRange'> {
  constructor(
    readonly key: number,
    readonly segmentMstCodeRange: WithExclusionObject,
  ) {}

  static init(key: number) {
    return new SingleSegmentMstRange(key, { body: '', isExcluded: false });
  }
}

class SingleSegmentMstRangeRaw
  implements Pick<SegmentMst['record'], 'isSegmentMstCodeRangeExcluded' | 'key' | 'segmentMstCodeRange'>
{
  private constructor(
    readonly key: number,
    readonly segmentMstCodeRange: string,
    readonly isSegmentMstCodeRangeExcluded: boolean,
  ) {}

  static fromModel(m: SingleSegmentMstRange) {
    return new SingleSegmentMstRangeRaw(m.key, m.segmentMstCodeRange.body, m.segmentMstCodeRange.isExcluded);
  }
}

export { SingleSegmentMstRange, SingleSegmentMstRangeRaw };
